import { useEffect } from 'react';

import { useAuthSocket } from '@/shared/services/socket/auth.service';

import { useAuthFlow } from './useAuthFlow';

export const useTokenRefreshWatch = () => {
  const { refreshToken } = useAuthFlow();
  const socket = useAuthSocket();

  useEffect(() => {
    if (!socket) return;
    socket.on('auth:need_refresh', refreshToken);
  }, [socket]);
};
